import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Row.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\MotionComponents\\Achievements.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\MotionComponents\\SteeringHomepage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\OurExperties\\OurExperties.js");
